import { SelectChangeEvent } from '@mui/material/Select';
import { sort } from 'fast-sort';
import {
  ConditionalTemplateAnswer_FieldsFragment,
  ConditionalTemplateAnswerFilterInput,
  ConditionalTemplateQuestion_FieldsFragment,
  useConditionalTemplateAnswer_GetConditionalTemplateAnswersByQuestionIdQuery,
} from 'queries';

import FormSelectField from 'common/form-select-field';

type TemplateQuestionAnswerSelectProps = {
  portalId: string;
  question: ConditionalTemplateQuestion_FieldsFragment;
  onChange: (value?: ConditionalTemplateAnswer_FieldsFragment) => void;
  value?: string;
  conditionalTemplateAnswerFilters?: ConditionalTemplateAnswerFilterInput[];
  questionIndex: number;
  totalQuestions: number;
};

const TemplateQuestionAnswerSelect = ({
  portalId,
  question,
  onChange,
  value,
  conditionalTemplateAnswerFilters,
  questionIndex,
  totalQuestions,
}: TemplateQuestionAnswerSelectProps) => {
  const answeredQuestions =
    conditionalTemplateAnswerFilters?.filter(
      (filter) => filter?.conditionalTemplateQuestionId && filter?.filterAnswerId,
    ) ?? [];
  const hasUnAnsweredQuestions = answeredQuestions.length < questionIndex;

  const { data: conditionalTemplateAnswersData } =
    useConditionalTemplateAnswer_GetConditionalTemplateAnswersByQuestionIdQuery({
      variables: {
        input: {
          portalId,
          conditionalTemplateQuestionId: question.id,
          conditionalTemplateAnswerFilterInputs: conditionalTemplateAnswerFilters,
        },
      },
      skip: hasUnAnsweredQuestions,
    });

  const answers = conditionalTemplateAnswersData?.data || [];
  const sortedAnswers = sort(answers).asc((answer) => answer.answer);

  const handleChange = (evt: SelectChangeEvent<unknown>) => {
    const answerId = evt.target.value as string;
    const answer = answers.find((a) => a.id === answerId);
    onChange(answer);
  };

  return (
    <FormSelectField
      label={`${questionIndex + 1} / ${totalQuestions}: ${question.question}`}
      onChange={handleChange}
      options={sortedAnswers.map((answer) => ({
        label: answer.answer,
        value: answer.id,
      }))}
      disabled={hasUnAnsweredQuestions}
      value={value}
    />
  );
};

export default TemplateQuestionAnswerSelect;
